import React from 'react'
import { T } from '@transifex/react'

import { createRoutesMapContainerGroup } from './container-group'
import { createRoutesMapContainers } from './containers'
import { createRoutesMapKeys } from './keys'
import { pathJoin } from '../../../utils'

export const createRoutesMapAssetManagement = (prefix: string) => ({
  containers: pathJoin(prefix)('containers').chainMapAuto(
    createRoutesMapContainers,
    {
      title: <T _str="All Containers" />,
      breadCrumbTitle: <T _str="All Containers" />,
    }
  ),
  'container-group': pathJoin(prefix)(`container-group`).chainMapAuto(
    createRoutesMapContainerGroup,
    {
      title: <T _str="All Container Groups" />,
      breadCrumbTitle: <T _str="All Container Groups" />,
    }
  ),
  rental: pathJoin(prefix)('rental').chainWithTitle({
    title: <T _str="Rental" />,
    breadCrumbTitle: <T _str="Rental" />,
  }),
  keys: pathJoin(prefix)('keys').chainMapAuto(createRoutesMapKeys, {
    title: <T _str="Keys" />,
    breadCrumbTitle: <T _str="Keys" />,
  }),
})
